import React, { useState, useEffect, useContext } from 'react';
import { Search } from 'lucide-react';
import { CartContext } from '../CartContext';
import ProductCard from './ProductCard';
import AddToCartModal from './AddToCartModal';
import { ShoppingCart } from "lucide-react";

export default function ProductListPage({ user,setPage  }) {
  const { addToCart, cart } = useContext(CartContext);
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const API_BASE_URL = window._config?.apiBaseUrl || '';
  const [likedItems, setLikedItems] = useState([]);
  const DATABASE_KEY = window._config?.databaseKey || '';

  // Helper function to get quantity from cart for a product
  const getCartQuantity = (productId) => {
    const cartItem = cart?.find(item => item.id === productId);
    return cartItem ? cartItem.quantity : 0;
  };

useEffect(() => {
  const vid = localStorage.getItem("vid");
  if (!vid) return;

  fetch(`${API_BASE_URL}/GetLikedItemList?Vid=${vid}&databaseKey=${DATABASE_KEY}`)
    .then(res => res.json())
    .then(data => {
      const items = data?.GetLikedItemList?.Table || [];
      const ids = items.map(item => item.itemid);
      setLikedItems(ids);
    })
    .catch(err => console.error("Liked fetch error:", err));
}, []);

  useEffect(() => {
    if (!user?.name) return;

    const apiUrl = `${API_BASE_URL}/GetItemList?user=${encodeURIComponent(user.name)}&databaseKey=${window._config?.databaseKey || ''}`;

    fetch(apiUrl)
      .then(res => res.json())
      .then(data => {
        const fetchedItems = data?.GetItemListjs?.Table || [];
        const formatted = fetchedItems.map(item => ({
          id: item.itemid,
          partno: item.item_no,
          name: item.Item_desc1,
          price: item.standardcost ?? 0,
          image: sanitizeImageUrl(item.filepath),
        }));
        setProducts(formatted);
      })
      .catch(error => console.error('Fetch error:', error));
  }, [user]);

  const sanitizeImageUrl = (url) => {
    if (!url) return 'https://placehold.co/400x400?text=No+Image';
    try {
      const cleanPath = url.replace(/^http:\/\/\/?/, 'http://');
      return cleanPath.startsWith('http') ? cleanPath : `http://${cleanPath}`;
    } catch {
      return 'https://placehold.co/400x400?text=Invalid+Image';
    }
  };

  const filteredProducts = products.filter(product =>
    product.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const totalItems =
  cart?.reduce((sum, item) => sum + item.quantity, 0) || 0;

  return (
  <div className="bg-gradient-to-br from-rose-50 via-white to-teal-50 min-h-screen">

    {/* 🌼 Hero Section */}
    <div className="text-center py-1 px-4">
      <h1 className="text-xl md:text-2xl font-extrabold text-teal-800">
        🌸 Welcome {user?.customer || user?.name}
      </h1>
      <p className="text-gray-600 mt-3 text-lg">
        From vibrant flowers 🌸 to fruit trees — discover nature’s best, ready for your garden.
      </p>

      <div className="mt-2 inline-block bg-white shadow-md px-4 py-2 rounded-full text-sm font-medium text-teal-700">
        {filteredProducts.length} Products Available
      </div>
    </div>

    {/* 🔍 Sticky Search Bar */}
    <div className="sticky top-0 z-20 bg-white/70 backdrop-blur-md py-4 shadow-sm">
      <div className="max-w-xl mx-auto px-4">
        <div className="relative">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search flowers, plants, bouquets..."
            className="w-full pl-12 pr-4 py-3 rounded-full border border-gray-300 focus:ring-2 focus:ring-teal-500 outline-none shadow-sm transition"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
    </div>

    {/* 🛍 Product Grid */}
    <div className="container mx-auto px-4 py-10">

      {filteredProducts.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">

          {filteredProducts.map(product => (
            <div
              key={product.id}
              className="transform hover:-translate-y-2 transition duration-300"
            >
            <ProductCard
              product={product}
              liked={likedItems.includes(product.id)}
              initialQuantity={getCartQuantity(product.id)}
              onAddToCartClick={(prod, qtyChange) => addToCart(prod, qtyChange)}
            />
            </div>
          ))}

        </div>
      ) : (
        <div className="text-center py-20">
          <div className="text-6xl mb-4">🌷</div>
          <p className="text-xl font-medium text-gray-600">
            No flowers found matching your search
          </p>
          <p className="text-gray-400 mt-2">
            Try searching with a different keyword.
          </p>
        </div>
      )}

    </div>

    {/* 🛒 Modal */}
    {selectedProduct && (
      <AddToCartModal
        product={selectedProduct}
        onAddToCart={addToCart}
        onClose={() => setSelectedProduct(null)}
      />
    )}

{totalItems > 0 && (
  <button
    onClick={() => setPage('cart')}
    className="fixed bottom-6 right-6 z-50 
               bg-gradient-to-r from-teal-500 to-emerald-600 
               text-white p-4 rounded-full 
               shadow-2xl hover:scale-110 active:scale-95 
               transition-all duration-300"
  >
    <div className="relative">
      <ShoppingCart size={24} />

      {/* Badge */}
      <span className="absolute -top-2 -right-2 
                       bg-red-500 text-white text-xs font-bold 
                       px-2 py-0.5 rounded-full shadow-md animate-bounce">
        {totalItems}
      </span>
    </div>
  </button>
)}
  </div>
);

}
